import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const stats = [
  { title: "Established in 2003", image: "https://img.freepik.com/free-vector/goal-achievement-teamwork-business-concept-career-growth-cooperation-development-project_107791-29.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" },
  { title: "Completed 23 Years...", image: "https://img.freepik.com/premium-vector/vintage-anniversary-emblem-23rd-gold-black-with-crown-wreath_769200-937.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" },
  { title: "1000+ Students", image: "https://img.freepik.com/free-vector/college-university-students-group-young-happy-people-standing-isolated-white-background_575670-66.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" },
  { title: "3000+ Alumni", image: "https://img.freepik.com/premium-photo/celebration-education-graduation-student-success-learning-concept_2379-1612.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" },
];

const Card = ({ title, image }) => {

  return (
    <div className="bg-white shadow-lg rounded-2xl p-6 text-center w-64 hover:bg-blue-200 transition duration-300">
      <img src={image} alt={title} className="w-16 h-16 mx-auto mb-4" />
      <h2 className="text-xl font-bold">{title}</h2>
    </div>
  );
};

const SVNCounts = () => {
        useEffect(() => {
            AOS.init({ duration: 1000 });
        }, []);
  return (
    <div className="flex flex-wrap justify-center gap-6 p-6" data-aos="fade-up">
      {stats.map((stat, index) => (
        <Card key={index} title={stat.title} image={stat.image} />
      ))}
    </div>
  );
};

export default SVNCounts;
